export interface Navigation {
    width: number;
}

const navigation: Navigation = {
    width: 250,
};

export default navigation;
